import React, { useCallback } from 'react';
import { Form as StyledForm } from './PatientResponsibleForm.styles.js';
import { Container, Button, Text } from '../../components/index.js';
import { PatientItem } from '../../views';
import { Input } from '@amigoapp/doca-react';
import { GENDER } from '../../constants/patient';

function PatientResponsible({
	handleCreateNewDependent,
	variant,
	handleSelectPatient,
	listMaxHeight,
	patients,
	showDependentForm,
	dependentData,
	onBackToPatientList,
	onDependentDataChange,
	onConfirmNewDependent,
	isFormValid
}) {
	const renderPatientItem = useCallback(
		(patient) => (
			<div className="doca-mb-6" key={patient.id}>
				<PatientItem
					patient={patient}
					handleCardClick={() => handleSelectPatient(patient)}
					variant={variant}
				/>
			</div>
		), [handleSelectPatient, variant]);

	const renderPatientKeyExtractor = (item) => item.id;

	if (showDependentForm) {
		return (
			<Container padded>
				<Text
					size="extra-large"
					weight="medium"
					style={{ color: '#26282A' }}
				>
					Dados do Dependente
				</Text>

				<Text
					size="small"
					weight="medium"
					marginTop={8}
					marginBottom={24}
					style={{ color: '#6b6b6b' }}
				>
					Preencha as informações obrigatórias de cadastrado para prosseguir
				</Text>

				<Input
					label="Data de nascimento"
					name="born"
					value={dependentData?.born}
					className="doca-mb-4"
					required
					type="tel"
					onChange={event => onDependentDataChange('born', event.target.value)}
					placeholder="DD/MM/AAAA"
				/>

				<div className="doca-form__field doca-form__field--required doca-mb-4">
					<label className="doca-form__label">Sexo</label>
					<div className="doca-flex doca-flex-row doca-justify-between doca-gap-4">
						<button
							type="button"
							className={`doca-shortcut w-100 ${dependentData?.gender === GENDER.male ? `doca-shortcut--${variant}` : ''}`}
							onClick={() => onDependentDataChange('gender', GENDER.male)}
						>
							<div>
								<i className="doca-icon doca-icon--large doca-icon__person" />
								<p className="doca-shortcut__title">Masculino</p>
							</div>
						</button>

						<button
							type="button"
							className={`doca-shortcut w-100 ${dependentData?.gender === GENDER.female ? `doca-shortcut--${variant}` : ''}`}
							onClick={() => onDependentDataChange('gender', GENDER.female)}
						>
							<div>
								<i className="doca-icon doca-icon--large doca-icon__person-dress" />
								<p className="doca-shortcut__title">Feminino</p>
							</div>
						</button>
					</div>
				</div>

				<Button
					variant={variant}
					block
					size="large"
					marginTop={24}
					marginBottom={16}
					disabled={!isFormValid}
					onClick={onConfirmNewDependent}
				>
					Continuar
				</Button>

				<Button
					variant="secondary"
					block
					size="large"
					onClick={onBackToPatientList}
				>
					<i className="doca-icon doca-icon__arrow-left"></i>
					Voltar
				</Button>
			</Container>
		);
	}

	return (
		<Container padded>
			<StyledForm.Header.Title
				size="extra-large"
				weight="medium"
				style={{ color: '#26282A' }}
			>
				Para quem será o agendamento?
			</StyledForm.Header.Title>

			<StyledForm.Header.Subtitle
				size="small"
				weight="medium"
				marginTop={8}
				style={{ color: '#6b6b6b' }}
			>
				Selecione o paciente que será atendido.
			</StyledForm.Header.Subtitle>

			<div className="doca-mt-6">
				{patients?.length > 0 ? (
					<StyledForm.FlatList
						data={patients}
						renderItem={renderPatientItem}
						renderItemKeyExtractor={renderPatientKeyExtractor}
						maxHeight={listMaxHeight}
						variant={variant}
					/>
				) : (
					<div className="doca-alert doca-alert--warning">
						Nenhum paciente cadastrado
					</div>
				)}
			</div>

			<Button
				variant="secondary"
				marginTop={24}
				block
				size="large"
				onClick={handleCreateNewDependent}
			>
				Novo paciente
			</Button>
		</Container>
	);
}

export default PatientResponsible;
